// Shared helpers for the scope-aware (Attendance / Diary) staff compliance views and exports.

/** scope = { includeAttendance, includeDiary } */
export const scopeTitle = (timeframe, { includeAttendance, includeDiary }) => {
  const period = { daily: 'Daily', weekly: 'Weekly', monthly: 'Monthly' }[timeframe] || '';
  if (includeAttendance && !includeDiary) return `Staff ${period} Attendance Compliance Audit`.replace('  ', ' ');
  if (includeDiary && !includeAttendance) return `Staff ${period} Daily Diary Audit`.replace('  ', ' ');
  return `Staff ${period} Compliance Audit`.replace('  ', ' ');
};

export const isDaily = (report) => report.timeframe === 'daily';
export const attDone = (r, daily) => (daily ? r.attendanceStatus === 'Submitted' : r.workingDays > 0 && r.attendanceDays === r.workingDays);
export const diaryDone = (r, daily) => (daily ? r.diaryStatus === 'Submitted' : r.workingDays > 0 && r.diaryDays === r.workingDays);

/** Plain-text attendance status: "09:15 AM" / "Pending" / "5/6 days". */
export const attText = (r, daily) => {
  if (r.holiday) return 'Holiday';
  if (!daily) return `${r.attendanceDays}/${r.workingDays} days`;
  return r.attendanceStatus === 'Submitted' ? (r.attendanceTime || 'Submitted') : 'Pending';
};
export const diaryText = (r, daily) => {
  if (r.holiday) return 'Holiday';
  if (!daily) return `${r.diaryDays}/${r.workingDays} days`;
  return r.diaryStatus === 'Submitted' ? (r.diaryTime || 'Submitted') : 'Pending';
};
